import Vue from 'vue'
import Vuex from 'vuex'
import search from './search'
import gps from './gps'
import app from './app'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    search: search,
    gps: gps,
    app: app
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js